import { rootApi } from "../../api/rootApi";

export const userRolesSBApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addUserRolesSupplyBeam: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/supply-beam/user-roles/add`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    getAllUserRolesSupplyBeam: builder.mutation({
      query: (params) => {
        return {
          method: "GET",
          url: `/supply-beam/user-roles`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
    updateUserRolesSupplyBeam: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/supply-beam/user-roles/${params.role_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.data,
        };
      },
    }),
    deleteUserRolesSupplyBeam: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/supply-beam/user-roles/${params.role_id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),
  }),
});

export const { useAddUserRolesSupplyBeamMutation,useDeleteUserRolesSupplyBeamMutation,useGetAllUserRolesSupplyBeamMutation,useUpdateUserRolesSupplyBeamMutation } = userRolesSBApi;
